import * as React from 'react';
import * as _ from 'lodash';
import * as qs from 'query-string';
import * as Cookies from 'universal-cookie';
import * as moment from 'moment';
import { connect, Dispatch } from 'react-redux';
import { IApplicationState, AppActionCreators, MatchingActionCreators, IMatchRunListResponse, IMatchRunResponse, IAppState, SwapActionCreators } from '@nkr/store/index';
import { IBaseResponse, IMatchRun } from '@nkr/models/index';
import { TableWrapper } from './styles';
import { Alert, FormControl, Glyphicon, Label } from 'react-bootstrap';
import { MatchRunStatus } from '@nkr/enums/match-run-status';
import { IRefreshInterval } from '../swap-management/swaps/models/refresh-interval';
import { toast } from 'react-toastify';
import OverlayMenuButton from '@nkr/components/overlay-menu-button';
import ConfirmDelete from './confirm-delete-modal';
import MediaQuery from 'react-responsive';
import TabsNew from "../swap-management/tabs-new";
import { ISwapCounts } from '../swap-management/models/swap-counts';

enum Actions {
    Results = 1,
    Delete = 2
}

enum Show {
    LastHour = 1,
    Today = 2,
    PastWeek = 3,
    PastMonth = 4,
    All = 5
}

interface IProps {
    isNew: boolean
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getMatchRuns: (isNew: boolean) => Promise<IMatchRunListResponse>,
    getMatchRun: (id: number) => Promise<IMatchRunResponse>,
    deleteMatchRun: (id: number) => Promise<IBaseResponse>
}

type TProps =
    IProps
    & IStateProps
    & IDispatchProps;

interface IState {
    list: IMatchRun[],
    matchRunSubmitted: boolean,
    show: Show,
    autoRefresh: number,
    loading: boolean,
    sortColumn: string,
    sortDirection: string,
    delete: {
        show: boolean,
        data: IMatchRun
    }
}

class MatchRunList extends React.Component<TProps, IState> {
    readonly state: IState = {
        list: [],
        matchRunSubmitted: false,
        show: Show.PastWeek,
        autoRefresh: 0,
        loading: false,
        sortColumn: 'completedDateTime',
        sortDirection: 'desc',
        delete: {
            show: false,
            data: null
        }
    }

    interval: any;

    refreshIntervals: IRefreshInterval[] = [
        { value: 0, label: 'Disable' },
        { value: 5, label: '5 seconds' },
        { value: 30, label: '30 seconds' },
        { value: 45, label: '45 seconds' },
        { value: 60, label: '60 seconds' }
    ];

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        let q = qs.parse(location.search);
        let matchRunSubmitted = q.s != null ? parseInt(q.s) == 1 : false;

        this.props.showLoading('Getting match runs, one moment please...').then(() => {
            this.props.getMatchRuns(this.props.isNew).then(response => {
                if (response.data.success) {
                    this.setState({
                        list: response.data.results,
                        matchRunSubmitted,
                    });
                }

                if (this.state.autoRefresh > 0) {
                    this.interval = setInterval(() => this.refresh(), 3000);
                }
            }).finally(() => {
                this.props.hideLoading();
            });
        });
    }

    getFilteredData = () => {
        let list = this.state.list.filter(x => {
            if (this.state.show == Show.LastHour) {
                return moment(x.completedDateTime, 'MM/DD/YYYY HH:mm') >= moment().add(-1, 'hour');
            }

            if (this.state.show == Show.Today) {
                return moment(x.completedDateTime, 'MM/DD/YYYY HH:mm') >= moment().startOf('day');
            }

            if (this.state.show == Show.PastWeek) {
                return moment(x.completedDateTime, 'MM/DD/YYYY HH:mm') >= moment().add(-1, 'week');
            }

            if (this.state.show == Show.PastMonth) {
                return moment(x.completedDateTime, 'MM/DD/YYYY HH:mm') >= moment().add(-1, 'month');
            }

            return true;
        });

        return _.orderBy(list, item => {
            switch (this.state.sortColumn) {
                case 'id': return item.id;
                case 'matchRunTypeDescription': return item.matchRunTypeDescription;
            case 'scenario': return item.scenario;
                case 'submittedDateTime': return moment(item.submittedDateTime, 'MM/DD/YYYY hh:mm').toDate();
                case 'startedDateTime': return moment(item.startedDateTime, 'MM/DD/YYYY hh:mm').toDate();
                case 'completedDateTime': return moment(item.completedDateTime, 'MM/DD/YYYY hh:mm').toDate();
            }
        }, this.state.sortDirection);
    }

    refresh = () => {
        this.setState({
            loading: true
        }, () => {
            this.props.getMatchRuns(this.props.isNew).then(response => {
                if (response.data.success) {
                    this.setState({
                        list: response.data.results,
                        loading: false
                    });
                }

                this.props.hideLoading();
            });
        });
    }

    setCookie = () => {
        var cookies = new Cookies();
        let { autoRefresh } = this.state;

        cookies.set('match-run-list', { autoRefresh, dateRecorded: new Date() }, { path: '/', domain: __DOMAIN__, secure: __ISSECURE__, httpOnly: false });
    }

    handleAction = (id: any, action: Actions) => {
        if (action == Actions.Results) {
            if (this.props.isNew) {
                window.open('/matching/results-new/' + id, '_blank');
            } else {
                window.open('/matching/results/' + id, '_blank');
            }
        }

        if (action == Actions.Delete) {
            let data = this.state.list.find(x => x.id == id);

            this.setState({
                delete: {
                    show: true,
                    data
                }
            });
        }
    }

    handleRefresh = () => {
        this.refresh();
    }

    handleShowChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            show: parseInt(e.currentTarget.value)
        });
    }

    handleAutoRefreshChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        this.setState({
            autoRefresh: parseInt(e.currentTarget.value),
            loading: false
        }, () => {
            clearInterval(this.interval);

            if (this.state.autoRefresh > 0)
                this.interval = setInterval(() => this.refresh(), this.state.autoRefresh * 1000);

            this.setCookie();
        });
    }

    handleDelete = () => {
        let id = this.state.delete.data.id;

        this.setState({
            delete: {
                show: false,
                data: null
            }
        }, () => {
            this.props.showLoading('Deleting match run, one moment please...').then(() => {
                this.props.deleteMatchRun(id)
                    .then(response => {
                        if (response.data.success) {
                            toast.success('Deleted match run');
                        }

                        this.refresh();
                    })
                    .catch(error => {
                        console.log(error);
                        this.props.hideLoading();
                    });
            });
        });
    }

    handleCancelDelete = () => {
        this.setState({
            delete: {
                show: false,
                data: null
            }
        });
    }

    handleSort = (sortColumn: string) => {
        let sortDirection = '';

        if (this.state.sortColumn == sortColumn) {
            if (this.state.sortDirection == 'desc') {
                sortDirection = 'asc'
                sortColumn = '';
            }

            if (this.state.sortDirection == 'asc') {
                sortDirection = 'desc';
            }
        } else {
            sortDirection = 'asc';
        }

        this.setState({
            sortColumn,
            sortDirection
        });
    }

    renderSort = (sortColumn: string) => {
        if (this.state.sortColumn == sortColumn) {
            if (this.state.sortDirection == 'asc') {
                return <Glyphicon glyph='chevron-up' />;
            } else {
                return <Glyphicon glyph='chevron-down' />;
            }
        }
    }

    renderProgress = (item: IMatchRun) => {
        let className = item.currentStage == '' ? 'label label-default' : 'label label-info';

        return (
            <div className={className} style={{ display: 'block', fontSize: '100%', width: '100%' }}>{item.currentStage != '' ? item.currentStage : 'Pending Execution...'}</div>
        );
    }

    render = () => {
        const showList = [
            { value: Show.LastHour, label: 'Last Hour', description: 'for the last hour...' },
            { value: Show.Today, label: 'Today', description: 'the today...' },
            { value: Show.PastWeek, label: 'Past Week', description: 'the past week...' },
            { value: Show.PastMonth, label: 'Past Month', description: 'the past month...' },
            { value: Show.All, label: 'All Time', description: '' },
        ];

        const currentShow = showList.find(x => x.value == this.state.show);

        const list = this.getFilteredData();

        return (
            <>
                <div className='container-fluid'>
                    <MediaQuery minWidth={1066}>
                        <TabsNew
                            tabKey={'PREVIOUS-MATCH-RUNS'}
                            subTabKey={''}
                            counts={null}
                            user={this.props.app.user}
                        />
                    </MediaQuery>

                    {this.state.matchRunSubmitted && (
                        <Alert bsStyle='success'>
                            Match run configuration submitted successfully.
                        </Alert>
                    )}

                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                        <div style={{ fontSize: 28, fontWeight: 500, width: '25%' }}>PREVIOUS MATCH RUNS</div>
                        <div style={{ textAlign: 'center', width: '30%' }}>
                            {this.state.loading && (
                                <div className='alert alert-info' style={{ marginBottom: 0, padding: 7.5, textAlign: 'center' }}>Refreshing match runs...</div>
                            )}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', width: '45%' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                                    <div style={{ marginRight: 5, fontSize: 12 }}>Show:</div>
                                    <div style={{ marginRight: 5 }}>
                                        <FormControl
                                            componentClass='select'
                                            value={this.state.show}
                                            onChange={this.handleShowChange}
                                        >
                                            {showList.map(show =>
                                                <option key={'show-' + show.value} value={show.value}>{show.label}</option>
                                            )}
                                        </FormControl>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                                    <div style={{ marginRight: 5, fontSize: 12 }}>Auto refresh:</div>
                                    <div style={{ marginRight: 5 }}>
                                        <FormControl
                                            componentClass='select'
                                            value={this.state.autoRefresh}
                                            onChange={this.handleAutoRefreshChange}
                                        >
                                            {this.refreshIntervals.map((interval, index) =>
                                                <option key={index} value={interval.value}>{interval.label}</option>
                                            )}
                                        </FormControl>
                                    </div>
                                    <div>
                                        <Glyphicon glyph='refresh' title='Refresh now' onClick={this.handleRefresh} />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <div style={{ overflowY: 'scroll', height: '85vh', border: '1px solid #ddd' }}>
                        <TableWrapper>
                            <thead>
                                <tr>
                                    <th style={{ cursor: 'default' }} onClick={() => this.handleSort('id')}>ID {this.renderSort('id')}</th>
                                    <th style={{ cursor: 'default' }} onClick={() => this.handleSort('matchRunTypeDescription')}>Type {this.renderSort('matchRunTypeDescription')}</th>
                                    <th style={{ cursor: 'default' }} onClick={() => this.handleSort('scenario')}>Scenario {this.renderSort('scenario')}</th>
                                    <th style={{ cursor: 'default' }} onClick={() => this.handleSort('submittedDateTime')}>Date Submitted {this.renderSort('submittedDateTime')}</th>
                                    <th style={{ cursor: 'default' }} onClick={() => this.handleSort('startedDateTime')}>Date Started {this.renderSort('startedDateTime')}</th>
                                    <th style={{ cursor: 'default' }} onClick={() => this.handleSort('completedDateTime')}>Date Completed {this.renderSort('completedDateTime')}</th>
                                    <th>Run Time</th>
                                    <th>NDD One-ways</th>
                                    <th>DD One-ways Configured</th>
                                    <th>Total One-ways</th>
                                    <th>Chain Starts</th>
                                    <th>Submitted By</th>
                                    <th>Status</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {list.map(item => {
                                    let menu = [];

                                    if (item.status == MatchRunStatus.Completed) {
                                        menu.push(
                                            { id: item.id, action: Actions.Results, include: true, selectable: true, element: <div style={{ width: 100 }}><Glyphicon glyph='list-alt' style={{ paddingRight: 10 }} /> Results</div> },
                                        );
                                    }

                                    if (item.status != MatchRunStatus.Running) {
                                        menu.push(
                                            { id: item.id, action: Actions.Delete, include: true, selectable: true, element: <div style={{ width: 100 }}><Glyphicon glyph='trash' style={{ paddingRight: 10 }} /> Delete</div> },
                                        );
                                    }

                                    return (
                                        <tr key={'item-' + item.id}>
                                            <td>{item.id}</td>
                                            <td>{item.matchRunTypeDescription}</td>
                                            <td>{item.scenario}</td>
                                            <td>{item.submittedDateTime}</td>
                                            <td>{item.startedDateTime}</td>
                                            <td>{item.completedDateTime}</td>
                                            <td>{item.completionTime}</td>

                                            {item.status == MatchRunStatus.Completed ?
                                                <>
                                                    <td>{item.nddOneWayCount}</td>
                                                    <td>{item.ddOneWaysConfigured}</td>
                                                    <td>{item.totalOneWays}</td>
                                                    <td>{item.chainStartCount}</td>

                                                </>
                                                :
                                                <td colSpan={4}>{this.renderProgress(item)}</td>
                                            }

                                            <td>{item.userFirstName} {item.userLastName}</td>
                                            <td>{item.statusDescription}</td>

                                            <td>
                                                {menu.length > 0 && (
                                                    <OverlayMenuButton
                                                        menu={menu}
                                                        bsStyle='primary'
                                                        bsSize='xs'
                                                        title='Actions'
                                                        listItemStyle={{ fontSize: 14 }}
                                                        onSelect={this.handleAction}
                                                    />
                                                )}
                                            </td>
                                        </tr>
                                    );
                                })}

                                {list.length == 0 && (
                                    <tr>
                                        <td colSpan={14} style={{ height: 300, border: '1px solid #ccc' }}>No match runs {currentShow.description}...</td>
                                    </tr>
                                )}
                            </tbody>
                        </TableWrapper>
                    </div>
                </div>

                <ConfirmDelete
                    show={this.state.delete.show}
                    data={this.state.delete.data}
                    onDelete={this.handleDelete}
                    onCancel={this.handleCancelDelete}
                />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        //centerList: appState.centers.list
        app: appState.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getMatchRuns: (isNew) => {
            return dispatch(MatchingActionCreators.getMatchRuns(isNew));
        },
        getMatchRun: (id) => {
            return dispatch(MatchingActionCreators.getMatchRun(id));
        },
        deleteMatchRun: (id) => {
            return dispatch(MatchingActionCreators.deleteMatchRun(id));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(MatchRunList)